import { FINTRAC_STR_COUNTRY_CODE } from 'app/modules/fintracStr/formConstants';
import { FintracFormValue } from 'app/modules/fintracStr/models';

export const isNorthAmericaCountry = (value: FintracFormValue) =>
  value === FINTRAC_STR_COUNTRY_CODE.CANADA.value ||
  value === FINTRAC_STR_COUNTRY_CODE.UNITED_STATES.value ||
  value === FINTRAC_STR_COUNTRY_CODE.MEXICO.value;
